<script setup lang="ts">
import { getMessageIDs } from './inputHelper'
const props = defineProps<{
  name: string
  error?: string
  hint?: string
  /** Bump this on every validation attempt to re-flash the error even when its text hasn't changed. */
  attempt?: number
}>()

const { hintId, errorId } = getMessageIDs(props.name)
// Keying on attempt forces the transition to replay even when the error text is identical to before.
const errorKey = computed(() => `${props.error}-${props.attempt ?? ''}`)
</script>

<template>
  <div class="input__message" v-if="hint || error">
    <Transition name="input__error-flash" mode="out-in">
      <div v-if="error" :key="errorKey" :id="errorId" class="input__error" aria-live="assertive">
        {{ error }}
      </div>
    </Transition>
    <div :id="hintId" class="input__hint">{{ hint }}</div>
  </div>
</template>

<style lang="postcss">
.input__message {
  margin-top: var(--space-20);
  font-size: var(--text-small);

  .input__error {
    color: var(--status-error);
  }

  .input__hint {
    margin-top: var(--space-20);
    color: var(--text-secondary);
  }

  .input__error-flash-enter-active,
  .input__error-flash-leave-active {
    transition: opacity 0.2s ease;
  }

  .input__error-flash-enter-from,
  .input__error-flash-leave-to {
    opacity: 0;
  }
}
</style>
